import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import keycloak from '@vindr/services/keycloak';
import { disableApprover } from './disableApprover';

const isDisableApprover = disableApprover([
  keycloak.hasOneOfPerm([PERMISSIONS.dashboard.admin_dashboard]),
  keycloak.isSuperAdmin(),
]);

export default isDisableApprover;
